import { requestData, receiveData, receiveError } from '../api/http'
import CloudFlyerAPI from '../api/CloudFlyerAPI'

export const LOCAL_NAVIGATION_PENDING = 'LOCAL_NAVIGATION_PENDING'
export const LOCAL_NAVIGATION_SUCCESS = 'LOCAL_NAVIGATION_SUCCESS'
export const LOCAL_NAVIGATION_ERROR   = 'LOCAL_NAVIGATION_ERROR'

export const LOCAL_SELECTION_CHANGED = 'LOCAL_SELECTION_CHANGED'

export const local_selection_changed = selection => ({
  type      : LOCAL_SELECTION_CHANGED,
  selection : selection
})

export const local_refresh = ({current_path}) => {
  return dispatch => {
    dispatch(requestData(LOCAL_NAVIGATION_PENDING))

    CloudFlyerAPI.file_catalyst
      .files
      .local(current_path)
      .then(res =>{
        if(!res)
          return dispatch(receiveError(LOCAL_NAVIGATION_ERROR))

        dispatch(receiveData(LOCAL_NAVIGATION_SUCCESS, ((res||{}).data||{})))
      })
      .catch(e =>{
        dispatch(receiveError(LOCAL_NAVIGATION_ERROR, e))
      })
  }
}
